import axios from "axios";
import {db_url} from "../url";

const DB_PayForms = (token) => {

    const add_url = '/dictionary/pay_forms'
    const getPayForms = (controller, page, size, search) => {
        return axios.get(db_url + `/dictionary/pay_forms?page=${page}&size=${size}&${search}`, {
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }

    const getPayForm = (id) => {
        return axios.get(db_url + `/dictionary/pay_forms/${id}`, {
            headers: {
                Authorization: token
            }
        })
    }

    const savePayForm = (data) => {
        return axios.post(db_url + `/dictionary/pay_forms`, data,{
            headers: {
                Authorization: token
            }
        })
    }

    const changeStatusPayForm = (id) => {
        return axios.put(db_url + `/dictionary/pay_forms/${id}`, null, {
            headers: {
                Authorization: token
            }
        })
    }

    // const deletePayForm = (id) => {
    //     return axios.delete(db_url + `/dictionary/pay_forms/${id}`, {
    //         headers: {
    //             Authorization: token
    //         }
    //     })
    // }

    const filterPayForm = (branch_id) => {
        return axios.get(db_url + add_url + '/filter', {
        // return axios.get("http://127.0.0.1:3002/api_web/v1" + add_url + '/filter', {
            params: {
                branch_id: branch_id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const branchesPayForms = (branch_id) => {
        return axios.get(db_url + add_url + '/branch', {
            // return axios.get('http://127.0.0.1:3002/api_web/v1' + add_url + '/branch', {
            params: {
                branch_id: branch_id
            },
            headers: {
                Authorization: token
            }
        })
    }

    return {
        getPayForms,
        getPayForm,
        changeStatusPayForm,
        // deletePayForm,
        savePayForm,
        filterPayForm,
        branchesPayForms,
    }
}

export default DB_PayForms